<template>
    <div>
         <v-app-bar fixed height=65>
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
         <div class="d-flex align-center">
            <v-img
            alt="Vuetify Logo"
            
            :src="storeLogo"
            transition="scale-transition"
            max-height='50'
            max-width="250"
            />
            <!-- <v-spacer></v-spacer> -->
         </div>
         <v-spacer></v-spacer>
         <!-- <v-img></v-img> -->
           <v-btn icon append :to="{name:'Cart'}"> 
                <v-icon>mdi-cart-outline</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>mdi-account-circle-outline</v-icon>
            </v-btn>
        
    </v-app-bar>
        <v-container>
            <h1>My Orders</h1>
            <v-row justify='center'>
                <v-col lg=8>
                    <MyOrderCard v-for="order in orders" :key='order.id' :bill_total='order.bill_total' :order_date='order.order_date' :is_delivered='order.is_delivered' :order_items='order.order_items' :delivery_address='order.address'/>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>
<style scoped>
    .container
{
    margin-top:60px;
}
</style>
<script>

/*global myBaseURL*/
import axios from 'axios';
import MyOrderCard from '@/components/MyOrderCard.vue'


export default {
    name:'MyOrders',
    components:{
        MyOrderCard
    },
    data(){
        return {
            storeLogo:'',
            storeName:'',
            // orders:[
            //         {
            //             order_id:1,
            //             bill_total:'1200',
            //             order_date:'13/10/2020',
            //             is_delivered:false,
            //             address:{
            //                 line1:"Foo, Bar",
            //                 line2:"Foo, Bar 2",
            //                 city:"Ahmedabad",
            //                 state:"Gujarat",
            //                 pincode:"123456"
            //             },
            //             products:[
            //                 {
            //                     id:1,
            //                     product_img:"https://storage.googleapis.com/ecomm-local-images/inside-weather-90ApxSJTTdg-unsplash.jpg",
            //                     qty:1,
            //                 },
            //                 {
            //                     id:2,
            //                     product_img:"https://storage.googleapis.com/ecomm-local-images/inside-weather-90ApxSJTTdg-unsplash.jpg",
            //                     qty:3,
            //                 }
            //             ]

            //         },
            //         {
            //             order_id:2,
            //             bill_total:'1200',
            //             order_date:'12/01/2020',
            //             is_delivered:true,
            //             address:{
            //                 line1:"Foo, Bar",
            //                 line2:"Foo, Bar 2",
            //                 city:"Ahmedabad",
            //                 state:"Gujarat",
            //                 pincode:"123456"
            //             },
            //             products:[
            //                 {
            //                     id:1,
            //                     product_img:"https://storage.googleapis.com/ecomm-local-images/inside-weather-90ApxSJTTdg-unsplash.jpg",
            //                     qty:5,
            //                 },
            //                 {
            //                     id:2,
            //                     product_img:"https://storage.googleapis.com/ecomm-local-images/inside-weather-90ApxSJTTdg-unsplash.jpg",
            //                     qty:4,
            //                 }
            //             ]

            //         }
            // ]
            orders : []
        }
        
    },
    created(){
         axios.request({
            url: '/customer/orders/'+this.$route.params.store_slug,
            method: 'GET',
            baseURL: myBaseURL,
            headers: {
                'Authorization': 'Bearer '+ window.localStorage.access_token
            }
        }).then(response => {
            console.log(response.data);
            this.storeName=response.data.name
            this.storeLogo=response.data.logo
            this.orders = response.data.orders
        })
    }
}
</script>